// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ly5h","rootNoMargin":"styles_rootNoMargin__ifYsf"};